import { AngularFirestore } from '@angular/fire/firestore';

import { TranslateFireLoader } from '../loaders';

export function TranslateFactory(db: AngularFirestore) {
    return new TranslateFireLoader(db);
}
